import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider, ProtectedRoute, useAuth } from './auth';
import { AppShell, Container } from '@mantine/core';
import { LicenceTable, Header, LogoutPage } from './components';
import { TopNavigation } from './components/TopNavigation';
import { theme } from './theme';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import 'react-toastify/dist/ReactToastify.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
      refetchOnWindowFocus: false,
    },
  },
});

const HEADER_HEIGHT = 52;

function MainContent() {
  const { user } = useAuth();

  return (
    <AppShell
      withBorder={false}
      header={{ height: HEADER_HEIGHT }}
      padding={0}
    >
      <AppShell.Header zIndex={5} bg="transparent">
        <TopNavigation />
      </AppShell.Header>

      <AppShell.Main
        style={{
          backgroundColor: 'var(--mantine-color-default)',
          minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        }}
      >
        <Container size="xl" mt="lg" px="md" fluid>
          <Header 
            title="Licence Management" 
            description="Manage Sandbox Studio Licence"
          />
          <LicenceTable userRole={user?.role ?? undefined} />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}

function ProtectedApp() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <MainContent />
      </ProtectedRoute>
    </AuthProvider>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Notifications position="top-right" zIndex={1000} />
        <ToastContainer />
        <BrowserRouter>
          <Routes>
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/*" element={<ProtectedApp />} />
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default App;
